export const errorMessageUtil = (
  customError: string | string[] | Record<string, string[]>
) => {
  if (typeof customError === "string") {
    return customError;
  }

  if (Array.isArray(customError)) {
    return customError.join("\n");
  }

  if (typeof customError === "object" && customError !== null) {
    return Object.values(customError).flat().join("\n");
  }

  return "An unknown error occurred.";
};
